import { render, staticRenderFns } from "./PermissionDataRuleModal.vue?vue&type=template&id=7267210a&scoped=true&"
import script from "./PermissionDataRuleModal.vue?vue&type=script&lang=js&"
export * from "./PermissionDataRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267210a",
  null
  
)

export default component.exports